export default "__VITE_ASSET__3b7b9c62__"